import { useEffect, useState } from "react"
import { SwitchTransition } from "react-transition-group"
import FadeTransition from "../../../components/animations/FadeTransition"
import DotsPulse from "../../../components/animations/DotsPulse";

type CardRibbonProps = {
  type?: 'default' | 'personalized' | 'all-inclusive' | 'last-minute' | 'special',
  text: string,
}

const random = (min: number, max: number) => Math.floor(Math.random() * (max - min)) + min;

const CardRibbon = ({
  type = 'default',
  text,
}: CardRibbonProps) => {
  const [isLoading, setIsLoading] = useState(type === 'personalized');

  useEffect(() => {
    if (type === 'personalized') {
      setTimeout(() => {
        setIsLoading(false)
      }, random(500, 1000))
    }
  }, [type])

  if (type === 'personalized') {
    return (
      <div className={`card-ribbon card-ribbon__${type} !font-semibold leading-none`}>
        <SwitchTransition mode="out-in">
          <FadeTransition key={isLoading}>
            <span>
              {isLoading ? <DotsPulse color="white" className="px-0 py-0.5" /> : text}
            </span>
          </FadeTransition>
        </SwitchTransition>
      </div>
    )
  }

  return (
    <div className={`card-ribbon card-ribbon__${type} !font-semibold leading-none`}>{text}</div>
  )
}

export default CardRibbon
